import {dynamicFilterOperators} from "../dynamicFilterOperators";
import { vnTemplate } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import {amCharts_v4_date_basic_template} from "./amCharts_v4_date_basic_template";
import { filterSingle_multiLevel_selector_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingle_multiLevel_selector_template';
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import { vnApp_sentinelbi } from '../vnApp_sentinelbi';


declare var ko: any;
declare var page: any;


export class permalinkSearch_template extends vnTemplate {

    protected presetFilter: presetFilter_template;
    protected brandFilter: filterSingle_multiLevel_selector_template;
    protected metricFilter: filterSingle_multiLevel_selector_template;
    protected indicatorsChart: amCharts_v4_date_basic_template;
    protected dateRangeFilter: filterDate_template;
    protected searchField: filterSimple_template;
    protected pagination: pagination_template;
    protected resultsInfo: resultsInfo_template;
    protected exportDataCsv: exportDataCsv;
    protected annotationTooltip: infoButton_template;

    readonly metricValues = [
        {"id": "views", "name": "Views"},
        {"id": "visits", "name": "Visits"},
        {"id": "sessions", "name": "Sessions"},
    ];

    /**
     * @inheritDoc
     */
    protected getTemplateHtml(): string{

        return `

        <div class="page-content">

            <div id="report-results">

                <div class="page-header">
                    <h2 class="title-page">Page Performance</h2>

                    <div data-bind="if: reportStatusData()" class="report-status">
                        <div class="button-default"
                            data-bind="css: {
                                'status-ok': reportStatusData().status === 'LIVE',
                                'status-delayed': reportStatusData().status === 'DELAYED',
                                'status-error': reportStatusData().status === 'ERRORS'
                            }">
                            <span data-bind="css: {
                                'icon i-live': reportStatusData().status === 'LIVE'
                            }"></span>

                            <div class="status" data-bind="text: reportStatusData().status"></div>

                            <div data-bind="if: reportStatusData().status === 'DELAYED' || reportStatusData().status === 'ERRORS'">
                                <div class="report-status-tooltip">
                                    <p style="text-transform: none;" data-bind="html: reportStatusData().message"></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="w-justify block-filters filters-responsive">
                    <div class="w-left flex-none sidebar-filters-js-only">
                        <button data-bind="event: { click: onSidebarToggle }" class="button-default no-text icon i-preferences preferences no-after" type="button" title="report preferences">
                            <span class="hide-text">REPORT PREFERENCES</span>
                        </button>
                        <nav class="sidebar-default" data-bind="css: {'is-open': sidebarToggle()}">
                            <div class="sidebar-default-header">
                                <span class="label-default sidebar-default-header icon i-preferences">Report Preferences</span>
                                <button data-bind="event: { click: onSidebarToggle }" type="button" class="btn-close-default icon i-close"><span></span></button>
                            </div>

                            <div class="sidebar-default-body">
                                <div>
                                    <span class="label-default icon i-intervals">Interval</span>
                                    <ul class="sidebar-default-list">
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Hourly">
                                                <span>Hourly</span>
                                                <input type="radio" id="radio-hourly" name="switch-time-group" value="hourly" data-bind="event: {change: onTimeGroupSwitch.bind($data, 'hourly')}, checked: timeGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Daily">
                                                <span>Daily</span>
                                                <input type="radio" id="radio-daily" name="switch-time-group" value="daily" data-bind="event: {change: onTimeGroupSwitch.bind($data, 'daily')}, checked: timeGroupSwitch"/>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <span class="label-default icon i-dimensions">Dimensions</span>
                                    <ul class="sidebar-default-list">
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Default">
                                                <span>Default</span>
                                                <input type="radio" id="radio-dimension-time" name="switch-dimension-group" value="time" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'time')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Device">
                                                <span>Device</span>
                                                <input type="radio" id="radio-dimension-device" name="switch-dimension-device" value="device" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'device')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Traffic Classification">
                                                <span>Traffic Classification</span>
                                                <input type="radio" id="radio-dimension-trafficClassification" name="switch-dimension-trafficClassification" value="trafficClassification" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'trafficClassification')}, checked: dimensionGroupSwitch "/>
                                            </label>
                                        </li>                                        
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Operating System">
                                                <span>Operating System</span>
                                                <input type="radio" id="radio-dimension-os" name="switch-dimension-os" value="os" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'os')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Browser">
                                                <span>Browser</span>
                                                <input type="radio" id="radio-dimension-browser" name="switch-dimension-browser" value="browser" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'browser')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Ad Block">
                                                <span>Ad Block</span>
                                                <input type="radio" id="radio-dimension-adBlockerStatus" name="switch-dimension-adBlockerStatus" value="adBlockerStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'adBlockerStatus')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Geo">
                                                <span>Geo</span>
                                                <input type="radio" id="radio-dimension-geo" name="switch-dimension-geo" value="geo" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'geo')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="AMP">
                                                <span>AMP</span>
                                                <input type="radio" id="radio-dimension-ampStatus" name="switch-dimension-ampStatus" value="ampStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'ampStatus')}, checked: dimensionGroupSwitch "/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Referrer">
                                                <span>Referrer</span>
                                                <input type="radio" id="radio-dimension-referrer" name="switch-dimension-referrer" value="referrer" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'referrer')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>                                        
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Hostname">
                                                <span>Hostname</span>
                                                <input type="radio" id="radio-dimension-hostname" name="switch-dimension-hostname" value="hostname" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'hostname')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Login Status">
                                                <span>Login Status</span>
                                                <input type="radio" id="radio-dimension-loginStatus" name="switch-dimension-loginStatus" value="loginStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'loginStatus')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Plan">
                                                <span>Plan</span>
                                                <input type="radio" id="radio-dimension-plan" name="switch-dimension-plan" value="plan" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'plan')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Identity Source">
                                                <span>Identity Source</span>
                                                <input type="radio" id="radio-dimension-identity-source" name="switch-dimension-identity-source" value="identitySource" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'identitySource')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Robot Name">
                                                <span>Robot Name</span>
                                                <input type="radio" id="radio-dimension-robotName" name="switch-dimension-robotName" value="robotName" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'robotName')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Robot Category">
                                                <span>Robot Category</span>
                                                <input type="radio" id="radio-dimension-robotCategory" name="switch-dimension-robotCategory" value="robotCategory" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'robotCategory')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <span class="label-default icon i-dimensions">UTMs</span>
                                    <ul class="sidebar-default-list">
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Campaign">
                                                <span>UTM Campaign</span>
                                                <input type="radio" id="radio-dimension-utmCampaign" name="switch-dimension-utmCampaign" value="utmCampaign" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmCampaign')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Medium">
                                                <span>UTM Medium</span>
                                                <input type="radio" id="radio-dimension-utmMedium" name="switch-dimension-utmMedium" value="utmMedium" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmMedium')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Source">
                                                <span>UTM Source</span>
                                                <input type="radio" id="radio-dimension-utmSource" name="switch-dimension-utmSource" value="utmSource" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmSource')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <!-- ko if: customDimensionsNames().length > 0 -->
                                    <div>
                                        <span class="label-default icon i-dimensions">Custom Dimensions</span>
                                        <ul class="sidebar-default-list">
                                            <!-- ko foreach: customDimensionsNames -->
                                                <li>
                                                    <label class="label-checkbox-menu-default" title="Default" data-bind="attr: {title: name}">
                                                        <span data-bind="text: name"></span>
                                                        <input type="radio" data-bind="attr: { id: 'radio-dimension-' + name, name: 'switch-dimension-' + name, value: name }, event: { change: $parent.onDimensionGroupSwitch.bind($parent, name) }, checked: $parent.dimensionGroupSwitch"/>                            </label>
                                                </li>
                                            <!-- /ko -->
                                        </ul>
                                    </div>
                                <!-- /ko -->
                            </div>

                        </nav>
                    </div>

                    <nav class="sidebar-default sidebar-default-right" data-bind="css:{'is-open': isFiltersOpen()}">
                        <div class="sidebar-default-header">
                            <span class="label-default sidebar-default-header icon i-filters">Filters</span>
                            <button type="button" class="btn-close-default icon i-close" data-bind="event: { click: toggleOpenFilters }"><span></span></button>
                        </div>

                        <div class="sidebar-default-body">

                            <div>

                                <!-- ko foreach: dynamicFiltersGrouped -->

                                    <span class="form-label" data-bind="text: categoryName"></span>

                                    <div class="dynamic-filters w-add-filters-list">
                                    <!-- ko foreach: Object.values(names) -->

                                        <div class="filter-group">

                                            <div class="checkbox-group">
                                                <label class="icon i-dropdown-simple">
                                                    <input class="expected" type="checkbox" />
                                                </label>
                                            </div>

                                            <!-- ko foreach: filters -->

                                                <!-- ko if: type === 'multiSelect' -->
                                                    <div data-bind="template: {name: 'multiSelector-template', data: filter.getTemplateViewModel()}" class="has-multi"></div>
                                                <!-- /ko -->

                                                <!-- ko if: type === 'autoCompleteMultiSelect' -->
                                                    <div data-bind="template: {name: 'filterMultipleAutoComplete-template', data: filter.getTemplateViewModel()}"></div>
                                                <!-- /ko -->

                                            ${dynamicFilterOperators.html}

                                            <!-- /ko -->
                                        </div> <!-- End filter-group -->
                                    <!-- /ko -->
                                    </div>
                                <!-- /ko -->

                            </div>
                        </div>
                    </nav>

                    <div class="w-right flex-all block-default">
                        <div class="w-justify full-width">
                            <div class="w-left">
                                <div class="w-brand-filter">
                                        ${this.brandFilter.getHtmlBuild()}
                                </div>
                                <div>
                                    ${this.dateRangeFilter.getHtmlBuild()}
                                </div>

                                <div class="separator">
                                </div>

                                <button class="icon i-filters no-after filterToggle-btn" data-bind="event: {click: toggleOpenFilters}">Filters</button>

                            </div>

                            <div class="w-right ">
                                <div class="w-filter-preset hide-mobile" data-bind="visible: false, event: { mouseover: onMouseOverPreset, mouseout: onMouseOutPreset}">
                                    ` + this.presetFilter.getHtmlBuild() + `
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-justify">
                    <div class="w-left">
                        <div class="w-filters-selected">
                            <div id="filters-selected" class="filters-selected">
                                <!-- ko foreach: dynamicFilters -->
                                    <div data-bind="attr: { id: 'selected-' + name }, css: {'filter-excluded': filter.getTemplateViewModel().filterOperator() === 'exclude'}"></div>
                                <!-- /ko -->
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ko if: sampledDatesData() && sampledDatesData().length > 0 -->
                    <div class="w-block-message plus theme-light">
                        <div class="block-message-content">
                            <p><strong>Note:</strong> The selected date range includes periods where data was sampled.</p>
                        </div>
                    </div>
                <!-- /ko -->

                <div>

                    <section class="w-graph block-default rogue no-padding">
                        <div class="w-justify" style="width: 100%;margin-top: 1rem">
                            <!-- ko if: dimensionGroupSwitch() !== 'time' -->
                                <div class="block-filters w-left">
                                    ${this.metricFilter.getHtmlBuild()}
                                </div>
                            <!-- /ko -->
                            <div style="margin-right: 1rem" class="w-right" data-bind= "visible: timelineAnnotationsData().length">
                                <span class="label-annotation"></span>
                                <div class="w-tooltips-adv auto-height short pos-top-left">
                                    ${this.annotationTooltip.getHtmlBuild()}
                                </div>
                            </div>
                        </div>
                        <div class="graph" id="permalinksIndicatorsBySearchByDate-results">
                            ${this.indicatorsChart.getHtmlBuild()}
                        </div>
                    </section>

                    <div id="permalinksBySearchByDate-results">

                        <div class="list-header w-justify list-results-header">

                            <div class="w-left">
                                <div class="page-performance-title-row">
                                    <h2 class="section-title icon i-keywords">Search Page Paths</h2>
                                    <div class="top-pages-v2-metric-toggles" aria-label="Optional engagement columns">
                                        <button class="top-pages-v2-metric-toggle" type="button" data-bind="event: { click: toggleAverageViewDuration }, css: { 'is-active': showAverageViewDuration }, attr: { 'aria-pressed': showAverageViewDuration, title: showAverageViewDuration() ? 'Hide AVD column' : 'Show AVD column' }">
                                            <span class="icon" data-bind="css: { 'i-simplify': showAverageViewDuration(), 'i-expand': !showAverageViewDuration() }" aria-hidden="true"></span>
                                            <span>AVD</span>
                                        </button>
                                        <button class="top-pages-v2-metric-toggle" type="button" data-bind="event: { click: toggleEngagementBreakdown }, css: { 'is-active': showEngagementBreakdown }, attr: { 'aria-pressed': showEngagementBreakdown, title: showEngagementBreakdown() ? 'Hide 30s, 60s and 90s columns' : 'Show 30s, 60s and 90s columns' }">
                                            <span class="icon" data-bind="css: { 'i-simplify': showEngagementBreakdown(), 'i-expand': !showEngagementBreakdown() }" aria-hidden="true"></span>
                                            <span>30s / 60s / 90s</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="page-performance-results-meta">` + this.resultsInfo.getHtmlBuild() + `</div>
                            </div>

                            <div class="w-center">
                                `+ this.searchField.getHtmlBuild() + `
                            </div>


                            <div class="w-right">
                                ` + this.pagination.getHtmlBuild() + `
                                <button class="button-default icon i-export" type="button" data-bind="event: { click: exportData}">Export</button>
                            </div>

                        </div>

                        <div class="gradient-overflow">
                            <div class="w-list-results">
                                <table class="list-results list-sections page-performance-table" data-bind="css: { 'is-engagement-breakdown-visible': showEngagementBreakdown, 'is-average-view-duration-visible': showAverageViewDuration }">

                                    <thead>
                                        <tr class="table-metric-parent-headers page-performance-groups">
                                            <th></th>
                                            <th class="table-metric-parent-header table-metric-parent-header--traffic" scope="colgroup" colspan="3">Traffic</th>
                                            <th class="table-metric-parent-header table-metric-parent-header--engagement" scope="colgroup" data-bind="attr: { colspan: 6 + (showAverageViewDuration() ? 1 : 0) + (showEngagementBreakdown() ? 6 : 0) }">
                                                <div class="table-metric-parent-header-content"><span>Engagement</span></div>
                                            </th>
                                            <th class="table-metric-parent-header table-metric-parent-header--us" scope="colgroup" colspan="4">Marketability</th>
                                        </tr>
                                        <tr>
                                            <th><span data-bind="text: dimensionGroupSwitch() === 'time' ? 'Page Path' : 'Top Dimensions'"></span></th>
                                            <th>
                                                <span>Sessions</span>
                                            </th>

                                            <th>
                                                <span>Visits</span>
                                            </th>

                                            <th>
                                                <span>Views</span>
                                            </th>

                                            <th>
                                                <span>PG/S</span>
                                            </th>

                                            <th>
                                                <span>Eng. Visits</span>
                                            </th>

                                            <th data-bind="visible: showEngagementBreakdown()">
                                                <span class="duration-label">30<small class="duration-unit">s</small>+</span>
                                            </th>

                                            <th data-bind="visible: showEngagementBreakdown()">
                                                <span class="duration-label">60<small class="duration-unit">s</small>+</span>
                                            </th>

                                            <th data-bind="visible: showEngagementBreakdown()">
                                                <span class="duration-label">90<small class="duration-unit">s</small>+</span>
                                            </th>

                                            <th>
                                                <span>Eng. Views</span>
                                            </th>

                                            <th data-bind="visible: showEngagementBreakdown()">
                                                <span class="duration-label">30<small class="duration-unit">s</small>+</span>
                                            </th>

                                            <th data-bind="visible: showEngagementBreakdown()">
                                                <span class="duration-label">60<small class="duration-unit">s</small>+</span>
                                            </th>

                                            <th data-bind="visible: showEngagementBreakdown()">
                                                <span class="duration-label">90<small class="duration-unit">s</small>+</span>
                                            </th>

                                            <th>
                                                <span>Int. Ratio</span>
                                            </th>

                                            <th>
                                                <span class="duration-label">T<small class="metric-unit">o</small>P</span>
                                            </th>

                                            <th data-bind="visible: showAverageViewDuration()">
                                                <span>AVD (mm:ss)</span>
                                            </th>

                                            <th>
                                                <span>Depth</span>
                                            </th>

                                            <th>
                                                <span>Avg Speed (Mbps)</span>
                                            </th>

                                            <th>
                                                <span>Logged-In Sessions</span>
                                            </th>

                                            <th>
                                                <span>Logged-In Visits</span>
                                            </th>

                                            <th>
                                                <span>Logged-In Views</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- ko if : totalRow().length > 0 -->
                                            <tr class="total-row">
                                                <td>
                                                    <span data-bind="text: 'Total'"></span>
                                                </td>

                                                <!-- ko foreach: totalRow -->
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: Number(sessionCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) "></span>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: Number(visitCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) "></span>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: Number(viewCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) "></span>
                                                    </td>
                                                    <td><span class="row-percentage" data-bind="text: Number(viewsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) "></span></td>
                                                    <td><span class="row-percentage" data-bind="text: $parent.formatNullablePercentage(engagedVisitPercentage)"></span><small data-bind="text: ' (' + $parent.formatNullableNumber(engagedVisits) + ')'"></small></td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: $parent.formatNullablePercentage(engaged30SecondsVisitPercentage)"></span>
                                                        <small data-bind="text: ' (' + $parent.formatNullableNumber(engaged30SecondsVisits) + ')'"></small>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: $parent.formatNullablePercentage(engaged60SecondsVisitPercentage)"></span>
                                                        <small data-bind="text: ' (' + $parent.formatNullableNumber(engaged60SecondsVisits) + ')'"></small>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: $parent.formatNullablePercentage(engaged90SecondsVisitPercentage)"></span>
                                                        <small data-bind="text: ' (' + $parent.formatNullableNumber(engaged90SecondsVisits) + ')'"></small>
                                                    </td>
                                                    <td><span class="row-percentage" data-bind="text: $parent.formatNullablePercentage(engagedViewPercentage)"></span><small data-bind="text: ' (' + $parent.formatNullableNumber(engagedViews) + ')'"></small></td>
                                                    <td><span class="row-percentage" data-bind="text: $parent.formatNullablePercentage(engaged30SecondsViewPercentage)"></span><small data-bind="text: ' (' + $parent.formatNullableNumber(engaged30SecondsViews) + ')'"></small></td>
                                                    <td><span class="row-percentage" data-bind="text: $parent.formatNullablePercentage(engaged60SecondsViewPercentage)"></span><small data-bind="text: ' (' + $parent.formatNullableNumber(engaged60SecondsViews) + ')'"></small></td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: $parent.formatNullablePercentage(engaged90SecondsViewPercentage)"></span>
                                                        <small data-bind="text: ' (' + $parent.formatNullableNumber(engaged90SecondsViews) + ')'"></small>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: $parent.formatNullableInteractionRatio(interactionRatio)"></span>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: $parent.formatMinuteSeconds(timeOnPage)"></span>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: $parent.formatMinuteSeconds(avgViewEngagedSeconds) "></span>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: Number(avgViewEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' "></span>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: Number(avgConnectionSpeed).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) "></span>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: Number(avgLoggedInSessionPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' "></span>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: Number(avgLoggedInVisitPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' "></span>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: Number(avgLoggedInViewPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' "></span>
                                                    </td>
                                                <!-- /ko -->
                                            </tr>
                                        <!-- /ko -->

                                        <!-- ko foreach: rowData -->
                                            <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data)}, style: { 'background-color': $parent.selectedRows().indexOf($index()) !== -1 ? '#dbdbed' : '' }">

                                                <!-- ko if: $parent.dimensionGroupSwitch() === 'time' -->
                                                    <td>
                                                        <a data-bind="event: { click: $parent.stopPropagation }, attr: {href: '/permalink_details?' + $parent.getEncodedViewModelParams() + '&brand=' + brand + '&permalink=' + permalinkUrl}"><span data-bind="text: subdomain  && subdomain != 'www'? (subdomain + ' ... ' + permalink) : permalink"></span></a>
                                                        <a class="icon i-ext-link" data-bind="event: { click: $parent.stopPropagation }, attr: {href: permalinkUrl}" target="_blank"></a>
                                                    </td>
                                                <!-- /ko -->

                                                <!-- ko ifnot: $parent.dimensionGroupSwitch() === 'time' -->
                                                    <td>
                                                        <span data-bind="text: dimension"></span>
                                                    </td>
                                                <!-- /ko -->

                                                <td class=""><span data-bind="text: Number(sessionCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                                <td class=""><span data-bind="text: Number(visitCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                                <td class=""><span data-bind="text: Number(viewCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                                <td class=""><span data-bind="text: Number(viewsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                                <td class=""><span data-bind="text: $parent.formatNullablePercentage(engagedVisitPercentage)"></span><small data-bind="text: ' (' + $parent.formatNullableNumber(engagedVisits) + ')'"></small></td>
                                                <td class="">
                                                    <span data-bind="text: $parent.formatNullablePercentage(engaged30SecondsVisitPercentage)"></span>
                                                    <small data-bind="text: ' (' + $parent.formatNullableNumber(engaged30SecondsVisits) + ')'"></small>
                                                </td>
                                                <td class="">
                                                    <span data-bind="text: $parent.formatNullablePercentage(engaged60SecondsVisitPercentage)"></span>
                                                    <small data-bind="text: ' (' + $parent.formatNullableNumber(engaged60SecondsVisits) + ')'"></small>
                                                </td>
                                                <td class="">
                                                    <span data-bind="text: $parent.formatNullablePercentage(engaged90SecondsVisitPercentage)"></span>
                                                    <small data-bind="text: ' (' + $parent.formatNullableNumber(engaged90SecondsVisits) + ')'"></small>
                                                </td>
                                                <td class=""><span data-bind="text: $parent.formatNullablePercentage(engagedViewPercentage)"></span><small data-bind="text: ' (' + $parent.formatNullableNumber(engagedViews) + ')'"></small></td>
                                                <td class=""><span data-bind="text: $parent.formatNullablePercentage(engaged30SecondsViewPercentage)"></span><small data-bind="text: ' (' + $parent.formatNullableNumber(engaged30SecondsViews) + ')'"></small></td>
                                                <td class=""><span data-bind="text: $parent.formatNullablePercentage(engaged60SecondsViewPercentage)"></span><small data-bind="text: ' (' + $parent.formatNullableNumber(engaged60SecondsViews) + ')'"></small></td>
                                                <td class="">
                                                    <span data-bind="text: $parent.formatNullablePercentage(engaged90SecondsViewPercentage)"></span>
                                                    <small data-bind="text: ' (' + $parent.formatNullableNumber(engaged90SecondsViews) + ')'"></small>
                                                </td>
                                                <td class=""><span data-bind="text: $parent.formatNullableInteractionRatio(interactionRatio)"></span></td>
                                                <td class=""><span data-bind="text: $parent.formatMinuteSeconds(timeOnPage)"></span></td>
                                                <td class=""><span data-bind="text: $parent.formatMinuteSeconds(avgViewEngagedSeconds)"></span></td>
                                                <td class=""><span data-bind="text: Number(avgViewEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                                <td class=""><span data-bind="text: Number(avgConnectionSpeed).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                                <td class=""><span data-bind="text: Number(avgLoggedInSessionPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                                <td class=""><span data-bind="text: Number(avgLoggedInVisitPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                                <td class=""><span data-bind="text: Number(avgLoggedInViewPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                            </tr>
                                        <!-- /ko -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <footer class="default-footer">
                <span class="logo-short"></span>
                <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
                <span>|</span>
                <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
            </footer>
        `;
    }

    /**
     * @inheritDoc
     */
    protected initPartial(): void {

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('permalinkSearch');

        this.brandFilter = new filterSingle_multiLevel_selector_template('brandFilter', this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel('Property');
        this.brandFilter.setHasLogo(true);
        this.brandFilter.setDefaultLogo(vnApp_sentinelbi.BRAND_DEFAULT_ICON_PATH);

        this.metricFilter = new filterSingle_multiLevel_selector_template('metricFilter', this.getTemplateViewModel(), this.caller);
        this.metricFilter.setLabel('Metric');

        this.searchField = new filterSimple_template("searchField",this.getTemplateViewModel(),this.caller);

        this.pagination   = new pagination_template('pagination', this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.resultsInfo  = new resultsInfo_template('resultsInfo', this.getTemplateViewModel(), this.caller);

        this.exportDataCsv = new exportDataCsv();

        // Get the current date
        const currentDate = new Date();

        // Get the date for yesterday
        const yesterday = new Date(currentDate);
        yesterday.setDate(currentDate.getDate() - 1);

        // Get the date 7 days before yesterday
        const lastWeekStart = new Date(yesterday);
        lastWeekStart.setDate(yesterday.getDate() - 6);

        /* const twoDaysAgo = new Date(yesterday);
        twoDaysAgo.setDate(yesterday.getDate() - 1); */

        this.dateRangeFilter = new filterDate_template("dateRangeFilter", this.getTemplateViewModel(), this.caller);
        this.dateRangeFilter.setStartPickerId('dateRangeStartDatePicker');
        this.dateRangeFilter.setEndPickerId('dateRangeEndDatePicker');
        this.dateRangeFilter.setDateRange(currentDate, currentDate);

        // Get the date 7 days before last week start
        const weekBeforeLastStart = new Date(lastWeekStart);
        weekBeforeLastStart.setDate(lastWeekStart.getDate() - 2);

        this.indicatorsChart = new amCharts_v4_date_basic_template('indicatorsChart', this.getTemplateViewModel(), this.caller);

        window.addEventListener('click', event => {

            const sidebarFilters = document.querySelector('.sidebar-filters-js-only');
            const addFiltersDropdown = document.querySelector('.sidebar-default-right');
            const addFiltersButton = document.querySelector('.filterToggle-btn');

            if(!sidebarFilters?.contains(event.target as Element)){
                this.getTemplateViewModel().sidebarToggle(false);
            }

            if(!addFiltersDropdown?.contains(event.target as Element) && !addFiltersButton?.contains(event.target as Element) && !(event.target as Element).closest('.form-auto-item') && !(event.target as Element).closest('.btn-f-s')){
                this.getTemplateViewModel().isFiltersOpen(false);
            }
        })

        this.annotationTooltip = new infoButton_template('annotationTooltip', this.getTemplateViewModel(), this.caller)
        this.annotationTooltip.setContent('');
    }

    /**
     * @inheritDoc
     */
    protected getTemplateName(): string{

        return 'permalinkSearch_template';
    }

    /**
     * @inheritDoc
     */
    public buildViewModel(): Object{

        let self = this;

        return {
            reportStatusData: ko.observable(),
            sampledDatesData: ko.observableArray([]),
            dynamicFiltersData: ko.observableArray([]),
            dynamicFilters: ko.observableArray([]),
            dynamicFiltersGroupedByName: ko.observableArray([]),
            dynamicFiltersGrouped: ko.observableArray([]),
            customDimensionsNames: ko.observableArray([]),
            selectedBrand: ko.observable('brand_23'),
            rowData: ko.observableArray([]),
            totalRow: ko.observableArray([]),
            isDataHourly: ko.observable(false),
            graphAxes: ko.observableArray([]),
            graphLinesInfo: ko.observableArray([]),
            indicatorsDateRange: ko.observableArray([]),
            indicatorsDateRangeEmpty: ko.observable(false),
            timelineAnnotationsData: ko.observableArray([]),
            isPresetVisible: ko.observable(false),
            permalinksExportData: ko.observableArray([]),
            dateStartSelected: ko.observable(),
            dateEndSelected: ko.observable(),
            indicatorGroupSwitch: ko.observable('sessions'),
            timeGroupSwitch: ko.observable('hourly'),
            dimensionGroupSwitch: ko.observable('time'),
            selectedRows: ko.observable([]),
            showEngagementBreakdown: ko.observable(false),
            showAverageViewDuration: ko.observable(false),
            exportData: function(){ self.getCsvData(); },
            toggleEngagementBreakdown: function(){
                self.getTemplateViewModel().showEngagementBreakdown(!self.getTemplateViewModel().showEngagementBreakdown());
            },
            toggleAverageViewDuration: function(){
                self.getTemplateViewModel().showAverageViewDuration(!self.getTemplateViewModel().showAverageViewDuration());
            },
            sidebarToggle: ko.observable(false),
            isFiltersOpen: ko.observable(false),
            toggleOpenFilters: function(data){
                self.toggleOpenFilters();
            },
            onClickRowClick: function(index, data){

                self.onClickRowClick(index);
            },
            onMouseOverPreset : function () {
                
                self.onMouseOverPreset();
            },
            onMouseOutPreset : function () {
                
                self.onMouseOutPreset();
            },
            stopPropagation: function(data, event){

                self.stopPropagation(event);
                return true;
            },
            formatMinuteSeconds: function(value){
                return self.formatMinuteSeconds(value);
            },
            formatNullableNumber: function(value){
                return self.formatNullableNumber(value);
            },
            formatNullablePercentage: function(value){
                return self.formatNullablePercentage(value);
            },
            formatNullableInteractionRatio: function(value){
                return self.formatNullableInteractionRatio(value);
            },
            onDimensionGroupSwitch: function(data, event){

                self.onDimensionGroupSwitch(data, event);
            },
            onTimeGroupSwitch: function(data, event){

                self.onTimeGroupSwitch(data, event);
            },
            onSidebarToggle: function(){
                self.onSidebarToggle();
            },
            getEncodedViewModelParams: function(){

                return self.getEncodedViewModelParams();
            }
        }


    }

    private getEncodedViewModelParams(): string {

        let viewModel = this.getViewModelForRequest();
        let params = new URLSearchParams();

        for (const [key, value] of Object.entries(viewModel['filters'])) {
            params.append(key, ko.toJSON(value));
        }

        return params.toString();
    }

    public toggleOpenFilters(){

        this.getTemplateViewModel().isFiltersOpen(!this.getTemplateViewModel().isFiltersOpen());
    }

    private onSidebarToggle(){

        this.getTemplateViewModel().sidebarToggle(!this.getTemplateViewModel().sidebarToggle());
    }

    public setDynamicFilters(dynamicFiltersData: Array<any>){

        let i = 0;
        let dynamicFilters = [];

        for (let category in dynamicFiltersData) {

            if (dynamicFiltersData.hasOwnProperty(category)) {

                let filtersData = dynamicFiltersData[category];

                filtersData.forEach((filterData) => {

                    let filter, filterId;

                    // multi select
                    if(filterData.type === 'multiSelect'){

                        filterId = filterData.id;
                        filter = new multipleSelector_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setLabel(filterData.name);
                        filter.setTagContainerId('selected-' + filterData.name);
                        filter.setTagContainerCaption('Selected ' + filterData.name + ':');
                        filter.setItems(filterData.values);
                        filter.setShowCount(true);
                        filter.setShowClear(true);

                        if(filterData.hasSearchFilter){

                            filter.setContainSearchEnabled(true);
                        }

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                    // multi select autocomplete
                    else if(filterData.type === 'autoCompleteMultiSelect'){

                        filterId = filterData.id;
                        filter = new filterMultipleAutoComplete_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setIsVisible(1);
                        //filter.setPlaceHolderText(filterData.name);
                        filter.setIcon("i-tag-a");
                        filter.setTagContainerId('selected-' + filterData.name);
                        filter.setTagContainerCaption('Selected ' + filterData.name + ':');
                        filter.setMinInputSuggestionLength(2);
                        filter.setLabel(filterData.name);
                        filter.setShowCount(true);
                        filter.setShowClear(true);

                        if(filterData.hasSearchFilter){

                            filter.setContainSearchEnabled(true);
                        }

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                })
            }
        }

        dynamicFilterOperators.initialize(dynamicFilters, this.caller);
        this.getTemplateViewModel().dynamicFilters(dynamicFilters);

        let dynamicFiltersGrouped = Object.values(dynamicFilters.reduce((acc, item) => {

            // Check if the category already exists
            if (!acc[item.categoryName]) {
                acc[item.categoryName] = {
                    categoryName: item.categoryName,
                    names: {}
                };
            }

            // Check if the name already exists within the category
            if (!acc[item.categoryName].names[item.name]) {
                acc[item.categoryName].names[item.name] = {
                    name: item.name,
                    filters: []
                };
            }

            // Push the filter into the correct name group
            acc[item.categoryName].names[item.name].filters.push({
                type: item.type,
                filter: item.filter,
                filterId: item.filterId
            });

            return acc;
        }, {}));

        this.getTemplateViewModel().dynamicFiltersGrouped(dynamicFiltersGrouped);

        let dynamicFiltersGroupedByName = Object.values(dynamicFilters.reduce((acc, item) => {

            if (!acc[item.name]) {
                acc[item.name] = { name: item.name, category: item.category, filters: [] };
            }
            acc[item.name].filters.push({ type: item.type, filter: item.filter, filterId: item.filterId });
            return acc;
        }, {}));

        this.getTemplateViewModel().dynamicFiltersGroupedByName(dynamicFiltersGroupedByName);

        // Custom dimension names
        let customDimensionsNames = dynamicFilters.reduce((acc, item) => {
            if (item.category === "Custom Dimensions" && !acc.find(obj => obj.name === item.name)) {
                acc.push({ name: item.filterId.split('-')[0] });
            }
            return acc;
        }, []);

        this.getTemplateViewModel().customDimensionsNames(customDimensionsNames);
    }

    public setDynamicAutoCompleteMultiSelectFilterItems(filterId, items){

        let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
        let filter = dynamicFilters.find(filters => filters.filter.idElement === filterId).filter;
        if (filter) {

            filter.setItems(items);
            this.getTemplateViewModel().dynamicFilters(dynamicFilters);
        }
        filter.setItems(items);
    }

    public setTimelineAnnotationsData(timelineAnnotationsData) {

        for(let i = 0; i < timelineAnnotationsData.length; i++) {

            timelineAnnotationsData[i].dateOrig = timelineAnnotationsData[i].date;
            timelineAnnotationsData[i].date = new Date(timelineAnnotationsData[i].date);
        }

        this.getTemplateViewModel().timelineAnnotationsData(timelineAnnotationsData);

        // format for tooltip
        let formattedAnnotationTooltip = '<ul>';
        for(let i = 0; i < timelineAnnotationsData.length; i++) {

            let formattedDate = timelineAnnotationsData[i].dateOrig.substring(0, 10)
            if (this.getTemplateViewModel().timeGroupSwitch() == "hourly") {

                formattedDate = timelineAnnotationsData[i].dateOrig.substring(0, 13)+'H'
            }
            formattedAnnotationTooltip += '<li class="col"><strong>' + formattedDate + '</strong><p>'+ timelineAnnotationsData[i].annotation +'</p></li>';
        }
        formattedAnnotationTooltip += '</ul>';


        this.annotationTooltip.setContent(formattedAnnotationTooltip);
    }

    public onIndicatorGroupSwitch(){

        let metric = this.metricFilter.getSelectedOption();
        this.getTemplateViewModel().indicatorGroupSwitch(metric);
        this.caller.getReportData();
    }

    public clearTimelineAnnotatonData(){

        this.getTemplateViewModel().timelineAnnotationsData([]);
    }

    /**
     * @inheritDoc
     */
    public getViewModelForRequest(): Object{

        let selectedDynamicFilters = [];
        let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
        if(typeof dynamicFilters !== "undefined" && dynamicFilters !== null && Object.keys(dynamicFilters).length !== 0) {

            for(let dynamicFilter of dynamicFilters) {

                if(dynamicFilter.type === 'multiSelect') {

                    let items = dynamicFilter.filter.getTemplateViewModel().items();
                    let searchKeyword = dynamicFilter.filter.getContainSearchFilterKeyword();
                    let selectedIds = dynamicFilter.filter.getTemplateViewModel().selectedItems();
                    let filteredItems = items.filter(item => selectedIds.includes(item.id));

                    if(filteredItems.length > 0 || searchKeyword != '') {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {

                                [dynamicFilter.name]: {

                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    items: filteredItems,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
                else if(dynamicFilter.type === 'autoCompleteMultiSelect') {

                    let selectedIds = dynamicFilter.filter.getTemplateViewModel().selectedItems();
                    let searchKeyword = dynamicFilter.filter.getContainSearchFilterKeyword();
                    let filteredItems = selectedIds;

                    if(filteredItems.length > 0 || searchKeyword != '') {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {

                                [dynamicFilter.name]: {

                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    items: filteredItems,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
            }
        }

        return {
            filters : {
                selectedDynamicFilters: dynamicFilterOperators.forRequest(selectedDynamicFilters, dynamicFilters),
                selectedBrand: this.brandFilter.getTemplateViewModel().selectedOption(),
                selectedBrandText: this.brandFilter.getTemplateViewModel().selectedOptionText(),
                dateFilterType: this.getTemplateViewModel().dateRangeFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateRangeFilter.startDate(),
                endDate: this.getTemplateViewModel().dateRangeFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateRangeFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateRangeFilter.toRange(),
                timeGroupSwitch: this.getTemplateViewModel().timeGroupSwitch(),
                indicatorGroupSwitch: this.metricFilter.getTemplateViewModel().selectedOption(),
                indicatorGroupSwitchText: this.metricFilter.getTemplateViewModel().selectedOptionText(),
                dimensionGroupSwitch: this.getTemplateViewModel().dimensionGroupSwitch(),
                keywords: this.getTemplateViewModel().searchField.filterKeyword()
            },
            pagination: this.getTemplateViewModel().pagination
        };
    }

    public getSelectedBrand(){

        return this.brandFilter.getTemplateViewModel().selectedOption();
    }

    /**
     * Build the date Picker calendar.
     */
    public buildDatePickerCalendar(){

        this.dateRangeFilter.buildCalendar();
    }

    public setReportStatusData(reportStatusData) {

        this.getTemplateViewModel().reportStatusData(reportStatusData);
    }

    public setSampledDatesData(sampledDatesData) {

        this.getTemplateViewModel().sampledDatesData(sampledDatesData);
    }

    public setDefaultDevices(){

        // Select by default Mobile, Desktop, Tablet
        const filter = this.getTemplateViewModel().dynamicFilters().find(f => f.filterId == 'device-internalDimension').filter;

        let defaultDevices = ['Mobile', 'Desktop', 'Tablet'];
        let filterItems = filter.getItems().filter(i => i && defaultDevices.includes(i.name));
        let filterItemIds = filterItems.map(i => i.id);

        if(filter.getTemplateName() === 'multiSelector-template'){

            filter.setSelectedItems(filterItems);
            filter.setTags(filterItemIds, filter.getItems());
        }

        dynamicFilterOperators.setDefaultHttpStatus(this.getTemplateViewModel().dynamicFilters());
    }

    public setMetricFilterItems() {

        const options = this.metricValues;

        let filterItems = options.map(o => {
            return {
                id: o.id,
                name: o.name,
                type: "",
                cssClasses: ""
            }
        });

        // set the groups manually (dont use setGroups here)
        this.metricFilter.getTemplateViewModel().groups(filterItems);

        // set default
        this.metricFilter.setSelectedOption(filterItems[2].id);
        this.metricFilter.setSelectedOptionText(filterItems[2].name);
    }

    public setIndicatorsData(indicatorsData) {

        this.getTemplateViewModel().isDataHourly(indicatorsData.isDataHourly);
        this.getTemplateViewModel().graphAxes(indicatorsData.graphAxes);
        this.getTemplateViewModel().graphLinesInfo(indicatorsData.graphLinesInfo);

        for(let i = 0; i < indicatorsData.dateRange.data.length; i++) {

            indicatorsData.dateRange.data[i].dateData = new Date(indicatorsData.dateRange.data[i].dateData);
        }

        this.getTemplateViewModel().indicatorsDateRange(indicatorsData.dateRange);
        this.getTemplateViewModel().indicatorsDateRangeEmpty(indicatorsData.dateRange.data.length > 0 ? false : true);
    }

    setBrandFilterItems(portfolios, hasAllBrands) {
        let groups = [];

        for (let portfolio of portfolios) {
            for (let brand of portfolio.brands) {
                let brandItem = {
                    id: brand.id,
                    name: brand.name,
                    iconUrl: brand.logoUrl,
                    type: 'brand'
                };
                groups.push(brandItem);
            }
        }

        // Sort brands alphabetically by name
        groups.sort((a, b) => a.name.localeCompare(b.name));

        if (groups && groups.length > 0) {

            this.brandFilter.setGroups(groups);
        }
    }

    public setBrandShortName(brandShortName) {

        this.getTemplateViewModel().brandShortName(brandShortName);
    }

    public setCusotmDimensionNames(customDimensions: Array<any>){

        this.getTemplateViewModel().customDimensions(customDimensions);
    }

    public setRowData(rowData){

        this.getTemplateViewModel().rowData(rowData);
    }

    public setTotalRow(totalRow){

        this.getTemplateViewModel().totalRow(totalRow);
    }

    public setCsvExportData(exportData){

        this.getTemplateViewModel().permalinksExportData(exportData);
    }

    public setDatesSelected(){

        this.getTemplateViewModel().dateStartSelected(this.getTemplateViewModel().dateRangeFilter.startDate());
        this.getTemplateViewModel().dateEndSelected(this.getTemplateViewModel().dateRangeFilter.endDate());
    }

    public exportCsvData(){

        let fileName;

        let exportDataView = [];
        for (let exportDataRow of this.getTemplateViewModel().permalinksExportData()) {

            let exportDataViewRow = this.getFormatedExportRow(exportDataRow);
            exportDataView.push(exportDataViewRow);
        }

        fileName = "permalinks_search_keyword_" + this.getTemplateViewModel().searchField.filterKeyword().replace(/[^\w\s]/gi, "_") + "_" + this.dateRangeFilter.getTemplateViewModel().startDate() + "_" + this.dateRangeFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportDataCsv.exportToCsv(fileName, exportDataView);
    }

    private getFormatedExportRow(exportDataRow) {

        let exportDataViewRow = [];


        if(this.getTemplateViewModel().dimensionGroupSwitch() === "time"){

            exportDataViewRow["Page Path"] = exportDataRow.permalink;
            exportDataViewRow["Full Page Path"] = exportDataRow.permalinkUrl;
        }
        else{

            exportDataViewRow["Dimension"] = exportDataRow.dimension;
        }
        exportDataViewRow["Session"] = Number(exportDataRow.sessionCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Visits"] = Number(exportDataRow.visitCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Views"] = Number(exportDataRow.viewCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Engaged Visits %"] = this.formatNullablePercentage(exportDataRow.engagedVisitPercentage);
        exportDataViewRow["Engaged Visits (count)"] = this.formatNullableNumber(exportDataRow.engagedVisits);
        exportDataViewRow["Engaged Views %"] = this.formatNullablePercentage(exportDataRow.engagedViewPercentage);
        exportDataViewRow["Engaged Views (count)"] = this.formatNullableNumber(exportDataRow.engagedViews);
        exportDataViewRow["Engaged Visits 30s %"] = this.formatNullablePercentage(exportDataRow.engaged30SecondsVisitPercentage);
        exportDataViewRow["Engaged Visits 30s (count)"] = this.formatNullableNumber(exportDataRow.engaged30SecondsVisits);
        exportDataViewRow["Engaged Views 30s %"] = this.formatNullablePercentage(exportDataRow.engaged30SecondsViewPercentage);
        exportDataViewRow["Engaged Views 30s (count)"] = this.formatNullableNumber(exportDataRow.engaged30SecondsViews);
        exportDataViewRow["Engaged Visits 60s %"] = this.formatNullablePercentage(exportDataRow.engaged60SecondsVisitPercentage);
        exportDataViewRow["Engaged Visits 60s (count)"] = this.formatNullableNumber(exportDataRow.engaged60SecondsVisits);
        exportDataViewRow["Engaged Views 60s %"] = this.formatNullablePercentage(exportDataRow.engaged60SecondsViewPercentage);
        exportDataViewRow["Engaged Views 60s (count)"] = this.formatNullableNumber(exportDataRow.engaged60SecondsViews);
        exportDataViewRow["Engaged Visits 90s %"] = this.formatNullablePercentage(exportDataRow.engaged90SecondsVisitPercentage);
        exportDataViewRow["Engaged Visits 90s (count)"] = this.formatNullableNumber(exportDataRow.engaged90SecondsVisits);
        exportDataViewRow["Engaged Views 90s %"] = this.formatNullablePercentage(exportDataRow.engaged90SecondsViewPercentage);
        exportDataViewRow["Engaged Views 90s (count)"] = this.formatNullableNumber(exportDataRow.engaged90SecondsViews);
        exportDataViewRow["Time on Page (mm:ss)"] = this.formatMinuteSeconds(exportDataRow.timeOnPage);
        exportDataViewRow["Interaction Ratio"] = this.formatNullableInteractionRatio(exportDataRow.interactionRatio);
        exportDataViewRow["PG/S"] = Number(exportDataRow.viewsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["AVD (mm:ss)"] = this.formatMinuteSeconds(exportDataRow.avgViewEngagedSeconds);
        exportDataViewRow["Scroll Depth %"] = Number(exportDataRow.avgViewEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
        exportDataViewRow["Avg Speed (Mbps)"] = Number(exportDataRow.avgConnectionSpeed).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["Logged-In Sessions"] = Number(exportDataRow.avgLoggedInSessionPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
        exportDataViewRow["Logged-In Visits"] = Number(exportDataRow.avgLoggedInVisitPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
        exportDataViewRow["Logged-In Views"] = Number(exportDataRow.avgLoggedInViewPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';

        return exportDataViewRow;
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultsInfo.setExecutionTime(execTime);
        this.resultsInfo.setNbResults(nbResults);
        this.resultsInfo.setNbPages(nbPages);
    }

    public updatePagination(totalCount){

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    private getCsvData(){

        this.caller.getListDataForCSV();
    }

    public onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);
        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    protected onMouseOverPreset(){

        this.getTemplateViewModel().isPresetVisible(true);
    }

    protected onMouseOutPreset(){

        this.getTemplateViewModel().isPresetVisible(false);
    }

    public stopPropagation(event){

        event.stopPropagation();
    }

    public updateIndicatorsGraphData(){

        this.indicatorsChart.setCssHeight("230px");

        let axes = this.getTemplateViewModel().graphAxes();
        let graphLines = this.getTemplateViewModel().graphLinesInfo();
        let chartData = this.getTemplateViewModel().indicatorsDateRange().data;

        this.indicatorsChart.setNbOfXAxes(axes.length)
        this.indicatorsChart.setDateFields(axes);
        this.indicatorsChart.setCursorEnabled(1);
        this.indicatorsChart.setLabelMaxWidth(80);
        this.indicatorsChart.setAutoRotateLabels(1);
        this.indicatorsChart.setClickableLegend(1);
        this.indicatorsChart.setXScrollbarEnabled(0);

        if(this.getTemplateViewModel().isDataHourly()) {

            this.indicatorsChart.setDateFormat("hourly");
        }
        else {

            this.indicatorsChart.setDateFormat("daily");
        }

        let chart = this.indicatorsChart.setupChart(chartData);

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        this.indicatorsChart.applyValueAxisFormatting(valueAxis);
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;

        valueAxis.title.fontWeight = "bold";
        valueAxis.min = 0;

        let count = 0;
        for (let graphLine of graphLines) {

            let series = chart.series.push(new am4charts.LineSeries());

            let color = permalinkSearch_template.getPaletteColor(count);
            series.dataFields.valueY =  graphLine.value;
            series.dataFields.customValue = graphLine.value;
            series.dataFields.dateX = graphLine.field;
            series.strokeOpacity = 1;
            series.strokeWidth = 2;
            series.fill = am4core.color(color);
            series.stroke = am4core.color(color);
            series.yAxis = valueAxis;
            series.name = graphLine.name;

            series.tooltipText = "{name}: [bold]{customValue}[/]";

            series.smoothing = "monotoneX";
            series.showOnInit = true;

            let interfaceColors = new am4core.InterfaceColorSet();

            let bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.radius = 4;
            bullet.circle.opacity = 1;
            bullet.circle.strokeWidth = 1;
            bullet.circle.stroke = interfaceColors.getFor("background");
            bullet.circle.opacity = 1;
            bullet.circle.strokeOpacity = 0.9;

            series.minBulletDistance = 2.5;

            count++;
        }

        chart.events.once("ready", () => {

            for (let annotation of this.getTemplateViewModel().timelineAnnotationsData()) {

                // Use the axis of a known series to choose the correct x-axis (you have multiple).
                const series0 = chart.series.getIndex(0) as am4charts.LineSeries;
                if (!series0 || !series0.xAxis) return;

                // Cast the axis to DateAxis so TS knows about min/max, strictMinMax, etc.
                const xAxis = series0.xAxis as am4charts.DateAxis;

                // The moment you want to mark:
                let eventDateTmp = annotation.date;


                let lineOffset = 43200000;
                if (this.getTemplateViewModel().timeGroupSwitch() == "hourly") {

                    lineOffset = 1800000;
                }else {

                    eventDateTmp.setHours(0, 0, 0, 0);
                }

                let offset = (eventDateTmp.getTimezoneOffset() * 60 * 1000);


                let eventDate = new Date(eventDateTmp.getTime() - offset + lineOffset);


                const ts = +eventDate;

                // Create the range and cast it to DateAxisDataItem so .value/.date are valid
                const range = xAxis.axisRanges.create() as am4charts.DateAxisDataItem;

                // Either set value (timestamp) or date (Date) — both are valid on DateAxisDataItem
                range.value = ts;              // or: range.date = eventDate;

                // Style the line
                range.grid.stroke = am4core.color("#FF0000");
                range.grid.strokeWidth = 2;
                range.grid.strokeOpacity = 1;
                range.grid.strokeDasharray = "4,4";
                range.grid.zIndex = 1000;

                // Label / note
                //range.label.text = "Annotation";
                range.label.rotation = -90;
                range.label.horizontalCenter = "right";
                range.label.verticalCenter = "bottom";
                range.label.dy = -150;                     // tweak up/down if needed

                range.label.inside = true;
                range.label.fill = am4core.color("#D41C5C");
                range.label.padding(0, 6, 0, 6);
            }
        });


        if(chart.logo){

            chart.logo.disabled = true;
        }
    }

    static getPaletteColor(number) {

        switch(number) {
            case 0:
                return "#312D69";
            case 1:
                return "#D8366D";
            case 2:
                return "#537749";
            case 3:
                return "#1E8EFF";
            case 4:
                return "#FED500";
            case 5:
                return "#E28413";
            default:
                return "#000000";  // Default case if number doesn't match any case
        }
    }

    static stringToColour(str){

        let hash = 0;
        for (let i = 0; i < str.length; i++){

            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        let colour = '#';
        for (let i = 0; i < 3; i++){

            let value = (hash >> (i * 8)) & 0xFF;
            colour += ('00' + value.toString(16)).substr(-2);
        }

        return colour;
    }

    public setViewModelFromRequest(params : Array<any>): void{

        if(typeof params['selectedBrand'] !== 'undefined'){

            this.brandFilter.getTemplateViewModel().selectedOption(params['selectedBrand']);
        }

        if(typeof params['selectedBrandText'] !== 'undefined'){

            this.brandFilter.getTemplateViewModel().selectedOptionText(params['selectedBrandText']);
        }

        if(typeof params['keywords'] !== 'undefined'){

            this.searchField.getTemplateViewModel().filterKeyword(params['keywords']);
        }

        if(typeof params['indicatorGroupSwitch'] !== 'undefined'){

            this.metricFilter.setSelectedOption(params['indicatorGroupSwitch']);
            this.getTemplateViewModel().indicatorGroupSwitch(params['indicatorGroupSwitch']);
        }

        if(typeof params['indicatorGroupSwitchText'] !== 'undefined'){

            this.metricFilter.setSelectedOptionText(params['indicatorGroupSwitchText']);
        }

        if(typeof params['dimensionGroupSwitch'] !== 'undefined'){

            this.getTemplateViewModel().dimensionGroupSwitch(params['dimensionGroupSwitch']);
        }

        this.presetFilter.setDates(this.dateRangeFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        if(typeof params['timeGroupSwitch'] !== 'undefined'){

            this.getTemplateViewModel().timeGroupSwitch(params['timeGroupSwitch']);
        }

        if(typeof params['selectedDynamicFilters'] !== 'undefined' && Array.isArray(params['selectedDynamicFilters'])){

            let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
            dynamicFilterOperators.restore(dynamicFilters, params['selectedDynamicFilters']);

            params['selectedDynamicFilters'].forEach(selectedDynamicFilter => {

                Object.values(selectedDynamicFilter).forEach(category => {

                    if (typeof category === 'object' && category !== null) {

                        Object.values(category).forEach(categoryFilter => {

                            let dynamicFilter = dynamicFilters.find(obj => obj.filter.idElement === categoryFilter.id);

                            if (dynamicFilter) {

                                let filter = dynamicFilter.filter;

                                if(categoryFilter.type === 'multiSelect'){

                                    if(categoryFilter.items.length > 0 || categoryFilter.keyword != ''){

                                        let filterIds = categoryFilter.items.map(obj => obj.id);
                                        this.presetFilter.setMultiSelectorPresetFilters(filter, filterIds, categoryFilter.keyword);
                                    }
                                }
                                else if(categoryFilter.type === 'autoCompleteMultiSelect'){

                                    if(categoryFilter.items.length > 0 || categoryFilter.keyword != ''){

                                        let filterIds = categoryFilter.items.map(obj => obj.id);
                                        let filterNames = categoryFilter.items.map(obj => obj.name);
                                        this.presetFilter.setMultipleAutocompletePresetFilter(filter, filterIds, filterNames, categoryFilter.keyword);
                                    }
                                }
                            }
                        });
                    }
                });

            });

            this.getTemplateViewModel().dynamicFilters(dynamicFilters);
        }
    }

    private formatMinuteSeconds(value){

        if (value === null || typeof value === 'undefined' || value === '' || value === 'null') {

            return '-';
        }

        if (isNaN(parseInt(value))) {

            return value;
        }else {

            return Math.floor(parseInt(value) / 60) + ":" + (parseInt(value) % 60).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            });
        }
    }

    private formatNullableNumber(value){

        if (value === null || typeof value === 'undefined' || value === '' || isNaN(Number(value))) {

            return '-';
        }

        return Number(value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
    }

    private formatNullablePercentage(value){

        if (value === null || typeof value === 'undefined' || value === '' || isNaN(Number(value))) {

            return '-';
        }

        return Number(value).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
    }

    private formatNullableInteractionRatio(value){

        return this.formatNullablePercentage(value);
    }

    public onTimeGroupSwitch(data, event){

        this.getTemplateViewModel().timeGroupSwitch(data);
        this.caller.getReportData();
    }

    public onDimensionGroupSwitch(data, event){

        this.getTemplateViewModel().dimensionGroupSwitch(data);
        this.caller.getReportData();
    }

    public setCustomDimensionLargeSetFilterItems(customDimension, customDimensionValues: Array<any>){

        let customDimensionLargeSetFilters = this.getTemplateViewModel().customDimensionLargeSetFilters();
        let filter = customDimensionLargeSetFilters.find(filters => filters.idElement === 'customDimensionLargeSetFilter-' + customDimension);
        if (filter) {

            filter.setItems(customDimensionValues);
            this.getTemplateViewModel().customDimensionLargeSetFilters(customDimensionLargeSetFilters);
        }
    }

    private isDateDifferenceWithinDays(startDate, endDate, numDays) {

        const dateA = new Date(startDate);
        const dateB = new Date(endDate);

        const diffInMs = Math.abs(dateA.getTime() - dateB.getTime());
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

        return (diffInDays + 1) <= numDays;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/permalinkSearch_template.ts